import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import Navbar from "./Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../api";

const socket = io("https://api.joss-serveur.duckdns.org");

function Layout({ children }) {
  const [notifications, setNotifications] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const fetchNotifications = async () => {
    try {
      const res = await API.get("/conversations");

      const notif = {};
      res.data.forEach((conv) => {
        if (conv.unread_count > 0) {
          notif[conv.id] = conv.unread_count;
        }
      });

      setNotifications(notif);
    } catch (err) {
      console.error("❌ erreur fetch notifications", err);
    }
  };

  useEffect(() => {
    if (!user.id) return;

    socket.emit("register", user.id);
    fetchNotifications();
  }, []);

  useEffect(() => {
    const handleNotification = () => {
      console.log("🔔 notif reçue → refresh DB");
      fetchNotifications();
    };

    socket.on("notification", handleNotification);

    return () => socket.off("notification", handleNotification);
  }, []);

  // ===============================
  // 📞 APPEL ENTRANT GLOBAL
  // ===============================
  useEffect(() => {
    const handleIncomingCall = ({ fromUser, offer }) => {
      console.log("📞 Appel entrant de :", fromUser);

      navigate(`/call/${fromUser.id}`, {
        state: {
          mode: "incoming",
          member: fromUser,
          offer,
        },
      });
    };

    socket.on("call:incoming", handleIncomingCall);

    return () => {
      socket.off("call:incoming", handleIncomingCall);
    };
  }, [navigate]);

  useEffect(() => {
    if (location.pathname.startsWith("/chat/")) {
      const id = location.pathname.split("/chat/")[1];

      API.post(`/conversations/${id}/read`);
      fetchNotifications();
    }
  }, [location]);

  const totalNotifications = Object.values(notifications).reduce(
    (a, b) => a + b,
    0
  );

  return (
    <div style={styles.container}>
      <div style={styles.content}>{children}</div>

      <div style={styles.navbar}>
        <Navbar notifications={notifications} total={totalNotifications} />
      </div>
    </div>
  );
}

export default Layout;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    background: "#0f172a",
    overflow: "hidden",
  },
  content: {
    flex: 1,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
  },
  navbar: {
    height: "70px",
    flexShrink: 0,
    borderTop: "1px solid #1e293b",
    background: "#020617",
  },
};